<script setup lang="ts">
import { Float } from '@headlessui-float/vue'
import { Menu } from '@headlessui/vue'
import type { HTMLAttributes } from 'vue'
import { cn } from '../utils'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <Menu
    v-slot="{ open }"
    as="div"
    :class="cn('relative inline-flex', props.class)"
  >
    <template v-if="open" />

    <Float
      portal
      :offset="8"
      :shift="8"
      :z-index="30"
      flip
      enter="transition ease-out duration-100"
      enter-from="transform opacity-0 scale-95"
      enter-to="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leave-from="transform opacity-100 scale-100"
      leave-to="transform opacity-0 scale-95"
      tailwindcss-origin-class
    >
      <slot />
    </Float>
  </Menu>
</template>
